import React, { useContext } from "react";
import { Redirect } from "react-router-dom";
import { AuthContext } from "src/context/Auth";

export default function AdminAuthGuard(props) {
  const { children } = props;
  const auth = useContext(AuthContext);
  if (!auth.adminIsLogin) {
    return <Redirect to="/" />;
  }

  return <>{children}</>;
}
